import { render, staticRenderFns } from "./RequestsAnalysis.vue?vue&type=template&id=a4535322&scoped=true"
import script from "./RequestsAnalysis.vue?vue&type=script&lang=js"
export * from "./RequestsAnalysis.vue?vue&type=script&lang=js"
import style0 from "./RequestsAnalysis.vue?vue&type=style&index=0&id=a4535322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4535322",
  null
  
)

export default component.exports